module.exports = __webpack_public_path__ + "img/id-lqtafsir-1.ca2f04e9.webp";